import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { withStyles } from '@material-ui/core/styles';
import SideMenu from './SideMenu';

const styles = theme => ({
  root: {
    width: '100%',
  },
  navbarLink: {
    color: '#4A4A4A',
    textDecoration: 'none',
    '&:hover': {
      color: '#4A4A4A',
      textDecoration: 'none',
    },
    alignSelf: 'center',
  },
  navbarItem: {
    borderBottom: '2px solid transparent',
    paddingTop: 8,
    paddingBottom: 8,
    '&:hover': {
        borderBottom: `2px ${theme.palette.primary.main} solid`,
        borderRadius: 1,
    }
  },
  navbarItemActive: {
    borderBottom: `2px ${theme.palette.primary.main} solid`,
    borderRadius: 1,
  },
});

class NavbarItem extends React.Component {
  state = {
    show: false,
  };

  toggleMenu = (show) => e => {
    e.preventDefault();
    this.setState({show});
  };
 
  render() {
    const { classes, label, link, menuItems } = this.props;

    return (
        <ListItem button className={classes.navbarItem} component='a' href={link}>
            <ListItemText className={classes.navbarLink}  primary={label}/>
            {menuItems && this.state.show && (
                <SideMenu items={menuItems} toggleMenu={this.toggleMenu}/>
            )}
            {menuItems && (
              <ListItemSecondaryAction>
                {this.state.show ? (
                  <IconButton onClick={this.toggleMenu(false)}>
                    <ChevronLeftIcon/>
                  </IconButton>
                ) : (
                  <IconButton onClick={this.toggleMenu(true)}>
                    <ChevronRightIcon/>
                  </IconButton>
                )}
                
              </ListItemSecondaryAction>
            )}
        </ListItem>
    )
  }
}

NavbarItem.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  menuItems: PropTypes.array,
};

export default withStyles(styles)(NavbarItem);
